import React from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';

export const ModalGeneric = ({ isOpen, onClose, onConfirm, message }) => {
    return (
        <ConfirmDialog
            className='w-11 desktop-max-width border-round-2xl'
            visible={isOpen}
            onHide={onClose}
            message={message}
            header={('Aviso')}
            icon="pi pi-exclamation-triangle"
            accept={onConfirm}
            reject={onClose}
            acceptLabel={('Confirmar')}
            rejectLabel={('Cancelar')}
            pt={{
                header: { className: 'border-round-top-2xl' },
                footer: {className: 'border-round-bottom-2xl'}
            }}
        />
    );
};
